import axios from "axios";
 
const instance = axios.create({
  // baseURL: "http://localhost:8811/api/",
  // baseURL: "http://192.168.13.13:8811/api/",
  baseURL: process.env.REACT_APP_BASE_URL,
});


instance.interceptors.response.use((res)=>res, err=>{
 

  if(err.response.status === 401){
    window.location = "/login"
    localStorage.clear();
  }
})

export default instance
